import { gql } from 'apollo-boost';

export const GET_PINNED_FOLDERS = gql`
    query($data: GetPinnedFoldersInput) {
        getPinnedFolders(data: $data) {
            folders {
                id
                title
                parent
                owner
                before
                isPinned
                pinnedRank
                deletedAt
                sharingStatus {
                    isShared
                    shareCount
                    isPublished
                }
            }
            cursor
        }
    }
`;
